export default [
  {
    path: "/event/:id/:name",
    component: () => import("@/views/menu/event/"),
    meta: {
      pageTitle: "Event",
      requireAuth: true,
      breadcrumb: [
        {
          text: "Paket",
          active: true,
        },
      ],
    },
  },
  {
    path: "/event/:id/:name/try-out",
    component: () => import("@/views/menu/event/list-try-out"),
    meta: {
      requireAuth: true,
      breadcrumb: [
        {
          text: "Paket",
        },
        {
          text: "Try Out",
          active: true,
        },
      ],
    },
  },
  {
    path: "/event/:id/:name/ebook",
    component: () => import("@/views/menu/event/list-ebook"),
    meta: {
      requireAuth: true,
      breadcrumb: [
        {
          text: "Paket",
        },
        {
          text: "Ebook",
          active: true,
        },
      ],
    },
  },
  {
    path: "/event/:id/:name/video",
    component: () => import("@/views/menu/event/list-video"),
    meta: {
      requireAuth: true,
      breadcrumb: [
        {
          text: "Paket",
        },
        {
          text: "Video",
          active: true,
        },
      ],
    },
  },
  {
    path: "/event/:id/:name/community",
    component: () => import("@/views/menu/event/list-class"),
    meta: {
      requireAuth: true,
      breadcrumb: [
        {
          text: "Paket",
        },
        {
          text: "Komunitas",
          active: true,
        },
      ],
    },
  },
];
